import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import Label from '../../atoms/label/label';
import FormValidation from '../../atoms/formEnums/formValidation';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import Select from '../../atoms/select/select';
import Imagen from '../../atoms/imagen/imagen';
import Icon, { IconSize, IconType } from '../../atoms/icon/icon';
import ExternalResource from '../../organisms/externalResourceModal/externalResourceModal';
import './formExternalResource.scss';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import { mapDispatchToProps } from '../../../store/externalCalls/api/uploadFilesApi';
import { storeStructure } from '../../../store/reducers';
import { httpGet } from '../../../store/externalCalls/httpCalls';

const FormExternalResource = (props) => {
  const {
    id,
    type,
    validation,
    label,
    helpText,
    fileType,
    onChange,
    value,
    getItemDonwloadable,
    saveItemDownloadable,
    getBackground,
    saveItemBackground,
    hasSelect,
    aspectRatio,
    allowedSizes,
    imageHeight,
    imageWidth,
    columClass,
    noImageText,
    loadingText,
    size,
    canUpload,
    canDelete,
    canUpdate,
    preview,
    disabled,
    errorResolution,
    linkCopy
  } = props;

  const [openModal, setOpenModal] = useState(false);

  const [data, setData] = useState({});
  const Uploadables = useSelector((state) => state[storeStructure.DownloadableFiles]);

  const [showAlertResolution,setShowAlertResolution] =useState(false);
  const [showCopyPopup, setShowCopyPopup] = useState(false);

  const onClickOpenModal = () => {
    setOpenModal(true);
  };

  const handleClose = (response) => {
    if (response !== undefined) {
      setData(response);
      onChange(response);
    }
    setOpenModal(false);
  };

  const handleRemove = () => {
    onChange({ id: null });
    setData({});
    setShowAlertResolution(false);
  };

  const handlerValueChange = (event) => {
    data.enabled = event.target.value === 'true';

    if (type === FormInputTypes.DOWNLOADABLE) {
      saveItemDownloadable(data);
    } else if (type === FormInputTypes.BACKGROUND) {
      saveItemBackground(data);
    }
  };

  const handleCopyLink = async () => {
  if (!data?.url) return;

    try {
      await navigator.clipboard.writeText(data.url);
      setShowCopyPopup(true);

      setTimeout(() => {setShowCopyPopup(false);}, 2000);
    } catch (error) {
      console.error("Error al copiar el enlace", error);
    }
  };

  useEffect(() => {
    if (value !== null && value !== '') {
      if (type === FormInputTypes.DOWNLOADABLE) {
        if(typeof value === 'object'){
          setData(value);
        }else{
          let found=Uploadables.find((elem=>elem.id===value));
          if(found){
            //check
             if(errorResolution){
              checkResolution(value)
             }
            setData(found);
          }else{
            getItemDonwloadable(value).then((resp) => {
              //check
              if(errorResolution)
                checkResolution(value);
              setData(resp);
            });
          }
        }
      }
      if (type === FormInputTypes.BACKGROUND) {
        getBackground(value).then((resp) => {
          setData(resp);
        });
      }
    } else {
      setData({});
    }
    // eslint-disable-next-line
  }, [value]);
  const checkResolution = (url) => {
    httpGet("checkResolutionUrl/" + url)
      .then((res) => {
        let currentSizes = res;

        const sizesArray = Array.isArray(allowedSizes)
          ? allowedSizes
          : [allowedSizes];

        const match = sizesArray.some(
          (size) =>
            size &&
            size.width === currentSizes.width &&
            size.height === currentSizes.height
        );

        setShowAlertResolution(!match);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  return (
    <div>
      <div className={`form-group row text-${validation}`}>
        {label !== "" && <Label helpText={helpText}>{label}</Label>}
        <div className={columClass}>
          {value && !data.url && (
            <div className="loading-spinner">
              <div></div>
              <div></div>
              <div></div>
            </div>
          )}
          {!data.url && loadingText && <div>{loadingText}</div>}
          {data.url !== undefined && [
            <Imagen
              key={`ìmg-${Label}`}
              className={
                "form-modal-button__preview " +
                (size ? "form-modal-button__size--" + size : "")
              }
              src={data.url}
              alt={`Downloadable file
              ${label}`}
            />,
            hasSelect !== false ? (
              <Select
                key={`Selelect-${label}`}
                className="form-modal-button__select"
                value={data.enabled}
                disabled={disabled}
                options={[
                  { name: "Enabled", value: true },
                  { name: "Disabled", value: false },
                ]}
                onChange={handlerValueChange}
              />
            ) : null,
            canDelete && (
              <Button
                key={`button-${Label}`}
                className="mr-2"
                id={`button-${id}-delete`}
                type={ButtonType.BUTTON}
                icon={IconType.DELETE}
                theme={ButtonTheme.ERROR}
                disabled={disabled}
                onClick={handleRemove}
              />
            ),
            <Button
            key={`button-copy-${id}`}
            className="mr-2"
            type={ButtonType.BUTTON}
            icon={IconType.COPY}
            disabled={disabled}
            onClick={handleCopyLink}
            />,
          ]}
          {canUpload &&
            (data.url == undefined ||
              (canUpdate && data.url !== undefined)) && (
              <Button
                id={`button-${id}`}
                key={`button-${Label}`}
                type={ButtonType.BUTTON}
                icon={IconType.UPLOAD}
                onClick={() => {
                  onClickOpenModal();
                }}
                disabled={disabled}
              />
            )}
          {showAlertResolution && errorResolution && (
            <div
              className="pr-3 pl-3 d-inline p-3 mb-2 text-black rounded"
              style={{ backgroundColor: "#eed692" }}
            >
              <span className="pr-3">
                <Icon
                  icon={IconType.ALERT}
                  iconSize={IconSize.SMALL}
                  iconColor="#725d00"
                />
              </span>
              {errorResolution}
            </div>
          )}
          {noImageText && <div>{noImageText}</div>}
          {showCopyPopup && (
            <div className="mt-2 d-flex align-items-center text-success">
            <Icon
              icon={IconType.CHECK}
              iconSize={IconSize.SMALL}
              className="mr-1"
            />
            Enlace copiado
            </div>
          )}
        </div>
      </div>
      <div>
        {openModal && (
          <ExternalResource
            id={id}
            type={type}
            currentData={data}
            onClose={handleClose}
            fileType={fileType}
            title={label}
            aspectRatio={aspectRatio}
            allowedSizes={allowedSizes}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
            onResolutionCheck={setShowAlertResolution}
          />
        )}
      </div>
    </div>
  );
};

FormExternalResource.propTypes = {
  /**
   * formtype
   */
  type: PropTypes.oneOf(Object.values(FormInputTypes)).isRequired,
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * ajust compontent to the parent with a css class
   */
  columClass: PropTypes.string,
  /**
   * Allowed file types
   */
  fileType: PropTypes.arrayOf(PropTypes.string),
  /**
   * function event with the value changes
   */
  onChange: PropTypes.func,
  /**
   * value resource reference
   */
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  /**
   * external call to get resource
   */
  getItemDonwloadable: PropTypes.func.isRequired,
  /**
   * external call to save resource
   */
  saveItemDownloadable: PropTypes.func.isRequired,
  /**
   * external call to get resource
   */
  getBackground: PropTypes.func.isRequired,
  /**
   * external call to save resource
   */
  saveItemBackground: PropTypes.func.isRequired,
  aspectRatio: PropTypes.string,
  allowedSizes:PropTypes.array,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  canUpload:PropTypes.bool,
  canDelete:PropTypes.bool,
  canUpdate:PropTypes.bool,
  size:PropTypes.string,
  disabled:PropTypes.bool
};

FormExternalResource.defaultProps = {
  validation: FormValidation.PENDING,
  label: '',
  helpText: '',
  columClass:'col-sm-8',
  fileType: [],
  onChange: () => {},
  aspectRatio: "",
  value: '',
  canUpload:true,
  canDelete:true,
  canUpdate:true,
  size:'',
  disabled:false
};

export default connect(null, mapDispatchToProps)(FormExternalResource);
